<template>
  <div class="exchange-admin-page">
    <a-card title="积分兑换履约">
      <div class="toolbar">
        <a-input class="keyword-input" v-model="query.exchangeNo" placeholder="兑换单号" allow-clear />
        <a-input class="keyword-input" v-model="query.customerName" placeholder="客户名称" allow-clear />
        <a-select v-model="query.status" placeholder="状态" allow-clear>
          <a-select-option v-for="item in statuses" :key="item" :value="item">{{ item }}</a-select-option>
        </a-select>
        <a-button type="primary" @click="loadData">查询</a-button>
      </div>
      <a-table row-key="id" :loading="loading" :columns="columns" :data-source="rows"
        :pagination="pagination" @change="changePage">
        <template slot="status" slot-scope="text"><a-tag :color="statusColor(text)">{{ text }}</a-tag></template>
        <template slot="action" slot-scope="text, record">
          <a @click="openDetail(record)">详情</a>
          <a-divider v-if="record.status === '待发货'" type="vertical" />
          <a v-if="record.status === '待发货' && record.giftCategory === '实物'" @click="openShip(record)">发货</a>
          <a-divider v-if="record.status === '待发货' && record.giftCategory === '实物'" type="vertical" />
          <a v-if="record.status === '待发货'" @click="closeRecord(record)">关闭并退积分</a>
        </template>
      </a-table>
    </a-card>

    <a-modal v-model="shipVisible" title="兑换礼品发货" @ok="submitShip">
      <a-form-model :model="shipForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
        <a-form-model-item label="快递公司"><a-input v-model.trim="shipForm.expressCompany" /></a-form-model-item>
        <a-form-model-item label="快递单号"><a-input v-model.trim="shipForm.expressNo" /></a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal v-model="detailVisible" title="兑换记录详情" :footer="null" width="720px">
      <a-descriptions v-if="detailRecord" bordered :column="2" size="small">
        <a-descriptions-item label="兑换单号">{{ detailRecord.exchangeNo || '--' }}</a-descriptions-item>
        <a-descriptions-item label="状态"><a-tag :color="statusColor(detailRecord.status)">{{ detailRecord.status || '--' }}</a-tag></a-descriptions-item>
        <a-descriptions-item label="礼品名称">{{ detailRecord.giftName || '--' }}</a-descriptions-item>
        <a-descriptions-item label="礼品分类">{{ detailRecord.giftCategory || '--' }}</a-descriptions-item>
        <a-descriptions-item label="客户名称">{{ detailRecord.customerName || '--' }}</a-descriptions-item>
        <a-descriptions-item label="消耗积分">{{ detailRecord.pointsAmount || 0 }}</a-descriptions-item>
        <a-descriptions-item label="收货人">{{ detailRecord.receiverName || '--' }}</a-descriptions-item>
        <a-descriptions-item label="联系电话">{{ detailRecord.receiverPhone || '--' }}</a-descriptions-item>
        <a-descriptions-item label="收货地址" :span="2">{{ detailRecord.receiverAddress || '--' }}</a-descriptions-item>
        <a-descriptions-item label="快递公司">{{ detailRecord.expressCompany || '--' }}</a-descriptions-item>
        <a-descriptions-item label="快递单号">{{ detailRecord.expressNo || '--' }}</a-descriptions-item>
        <a-descriptions-item label="创建时间">{{ detailRecord.createdAt || '--' }}</a-descriptions-item>
        <a-descriptions-item label="更新时间">{{ detailRecord.updatedAt || '--' }}</a-descriptions-item>
      </a-descriptions>
    </a-modal>
  </div>
</template>

<script>
import { getPointsExchangeList, shipPointsExchange, closePointsExchange } from '@/api'

export default {
  data() {
    return {
      loading: false,
      rows: [],
      query: {},
      statuses: ['待发货', '待收货', '已完成', '已关闭'],
      shipVisible: false,
      detailVisible: false,
      detailRecord: null,
      activeRecord: null,
      shipForm: { expressCompany: '', expressNo: '' },
      pagination: { current: 1, pageSize: 10, total: 0 },
      columns: [
        { title: '兑换单号', dataIndex: 'exchangeNo' },
        { title: '礼品', dataIndex: 'giftName' },
        { title: '分类', dataIndex: 'giftCategory' },
        { title: '客户', dataIndex: 'customerName' },
        { title: '消耗积分', dataIndex: 'pointsAmount' },
        { title: '快递公司', dataIndex: 'expressCompany' },
        { title: '快递单号', dataIndex: 'expressNo' },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' } },
        { title: '操作', key: 'action', width: 230, scopedSlots: { customRender: 'action' } }
      ]
    }
  },
  created() { this.loadData() },
  methods: {
    statusColor(status) {
      return { 待发货: 'orange', 待收货: 'blue', 已完成: 'green', 已关闭: 'default' }[status] || 'default'
    },
    openDetail(record) {
      this.detailRecord = record
      this.detailVisible = true
    },
    loadData() {
      this.loading = true
      getPointsExchangeList({ ...this.query, page: this.pagination.current, pageSize: this.pagination.pageSize })
        .then(res => {
          const data = res.data || {}
          this.rows = data.records || []
          this.pagination.total = data.total || 0
        }).finally(() => { this.loading = false })
    },
    changePage(page) {
      this.pagination.current = page.current
      this.pagination.pageSize = page.pageSize
      this.loadData()
    },
    openShip(record) {
      this.activeRecord = record
      this.shipForm = { expressCompany: record.expressCompany || '', expressNo: record.expressNo || '' }
      this.shipVisible = true
    },
    submitShip() {
      if (!this.shipForm.expressCompany || !this.shipForm.expressNo) return this.$message.warning('请填写快递公司和快递单号')
      shipPointsExchange(this.activeRecord.id, this.shipForm).then(() => {
        this.$message.success('兑换礼品已发货')
        this.shipVisible = false
        this.loadData()
      })
    },
    closeRecord(record) {
      const reason = window.prompt('请输入关闭原因，关闭后将退回积分并恢复礼品库存')
      if (!reason) return
      this.$confirm({
        title: '确认关闭兑换单？',
        content: '该操作会退回积分并恢复礼品库存。',
        onOk: () => closePointsExchange(record.id, { reason }).then(() => {
          this.$message.success('兑换单已关闭，积分和库存已退回')
          this.loadData()
        })
      })
    }
  }
}
</script>

<style scoped>
.exchange-admin-page { padding: 20px; }
.toolbar { margin-bottom: 16px; display: flex; gap: 10px; }
.toolbar .keyword-input { width: 140px; }
.toolbar .ant-select { width: 150px; }
</style>
